import { Button } from "src/components";
import downArrow from "src/assets/down-arrow.svg";
import { useState } from "react";
import moment from "moment";
import { downloadInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";

interface OrderInfoFuidCardProps {
  fuid: any;
  index: number;
  company_code: string;
}

const OrderInfoFuidCard = ({ fuid, index, company_code }: OrderInfoFuidCardProps) => {
  const [isExpanded, setIsExpanded] = useState(index === 0);
  const { toast } = useToast();

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="mt-6 w-full mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-6 bg-white">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            {/* M10-10765 */}
            <div className="flex items-center gap-4">
              {/* FUID Number */}
              <p className="font-semibold text-xl">
                FUID <span className="text-gray-500">#{fuid?.fuid_no}</span>
              </p>

              {/* Status Badge */}
              <span
                className="font-medium flex items-center justify-center text-sm h-6 px-3 rounded-full shadow-sm"
                style={{
                  backgroundColor: fuid?.fileStatusHdr?.color_code?.trim(),
                  color: fuid?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {fuid?.fileStatusHdr?.fuid_status_desc}
              </span>
            </div>
            {/* <div className="flex gap-2">
              <p
                className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full"
                style={{
                  backgroundColor: fuid?.fileStatusHdr?.color_code?.trim(),
                  color: fuid?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {fuid?.fileStatusHdr?.fuid_status_desc}
              </p>
              <p className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full bg-[#EAF4FF] text-[#002E6A]">
                {fuid?.orderCodes?.map((orderCode: any) => orderCode?.order_code).join(", ")}
              </p>
            </div>  */}
            <div className="mt-2 space-y-1">
              {/* Stockist Selected */}
              <div className="flex items-start gap-2">
                <p className="font-semibold min-w-[250px]">
                  Stockist Selected Order Number:
                </p>
                <span className="text-gray-700">
                  {fuid?.orderCodes
                    ?.map((orderCode: any) => orderCode?.order_code)
                    .join(", ") || "—"}
                </span>
              </div>

              {/* Invoice Considered */}
              <div className="flex items-start gap-2">
                <p className="font-semibold min-w-[250px]">
                  Invoice Considered Order Number:
                </p>
                <span className="text-gray-700">
                  {
                    Array.from(
                      new Set(
                        fuid?.invoice?.invoiceProducts?.flatMap((orderCode: any) =>
                          orderCode?.orderProductMappings?.map(
                            (invoiceOrder: any) => invoiceOrder?.orderProduct?.order?.order_code
                          )
                        ) || []
                      )
                    ).join(", ") || "—"
                  }
                </span>
              </div>
              {/* M10-10765 */}
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              className="font-normal text-white bg-[#8051FF]"
              onClick={() => {
                if (!fuid?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }

                toast({ title: "Downloading...", description: "Downloading invoice", variant: "default" });

                downloadInvoice(fuid?.file_path, company_code as string).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              Download
            </Button>
            <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          </div>
        </div>{" "}
        <div
          className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="border-t mt-6 border-[#d0d0d0]"></div>
          <div className="flex gap-10">
            <div className="mt-4 space-y-4 w-1/2">
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded on</p>
                <p className="text-[#303030]">{moment(fuid?.created_date).format("MMMM Do YYYY")}</p>
              </div>
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded by</p>
                <p className="text-[#303030]">{fuid?.uploader_name}</p>
              </div>
            </div>
            {fuid?.invoiceRemarks?.length > 0 && (
              <div className="mt-4 space-y-4 w-1/2">
                <p className="font-semibold text-[1.2rem]">Remarks</p>
                <p className="text-[#616161] inline-block mr-20">Category</p>
                <p className="text-[#303030] inline-block">
                  {fuid?.invoiceRemarks[0]?.RejectionInvoiceCategoryHdr?.rejection_inv_category_desc}
                </p>
                <div className="border space-y-1 mt-6 border-[#d0d0d0] min-h-[6rem] min-w-[20rem] w-fit rounded-lg bg-[#F1F1F1] p-4">
                  <p className="text-[#7F56D9] font-normal text-[1rem]">
                    {fuid?.invoiceRemarks[0]?.remarkby_type}
                  </p>
                  <p className="text-[#303030] font-normal text-[1rem]">
                    <span className="font-semibold">
                      {" "}
                      {fuid?.invoiceRemarks[0]?.invoiceRemarksHdr?.invoice_remarks_desc}
                    </span>{" "}
                    : ({fuid?.invoiceRemarks[0]?.freetxt_remarks})
                  </p>
                  <p className="text-[#616161] font-normal text-[.8rem]">
                    {moment(fuid?.invoiceRemarks[0]?.created_date).format("MMMM Do YYYY")}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderInfoFuidCard;
